/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Person,
  Player,
  Team,
  TeamEdit,
  TeamPaymentReceipt,
  TeamRegistrationRequest,
  UpdateTeamStatusRequest,
} from '../models/index';
import {
    PersonFromJSON,
    PersonToJSON,
    PlayerFromJSON,
    PlayerToJSON,
    TeamFromJSON,
    TeamToJSON,
    TeamEditFromJSON,
    TeamEditToJSON,
    TeamPaymentReceiptFromJSON,
    TeamPaymentReceiptToJSON,
    TeamRegistrationRequestFromJSON,
    TeamRegistrationRequestToJSON,
    UpdateTeamStatusRequestFromJSON,
    UpdateTeamStatusRequestToJSON,
} from '../models/index';

export interface DeleteTeamRequest {
    id: string;
}

export interface DeleteTeamPaymentReceiptRequest {
    id: string;
    tournamentId?: string;
}

export interface DownloadTeamPaymentReceiptRequest {
    id: string;
    tournamentId?: string;
}

export interface EditTeamRequest {
    id: string;
    teamEdit: TeamEdit;
}

export interface GetTeamByIdRequest {
    id: string;
}

export interface GetTeamOfficialsRequest {
    id: string;
}

export interface GetTeamPaymentReceiptRequest {
    id: string;
    tournamentId?: string;
}

export interface GetTeamPlayersRequest {
    id: string;
}

export interface RegisterTeamInTournamentRequest {
    id: string;
    teamRegistrationRequest: TeamRegistrationRequest;
}

export interface UpdateTeamOfficialsRequest {
    id: string;
    person: Array<Person>;
}

export interface UpdateTeamPlayersRequest {
    id: string;
    player: Array<Player>;
}

export interface UpdateTeamStatusOperationRequest {
    id: string;
    updateTeamStatusRequest: UpdateTeamStatusRequest;
}

export interface UploadTeamPaymentReceiptRequest {
    id: string;
    file: Blob;
    tournamentId?: string;
}

/**
 * TeamApi - interface
 * 
 * @export
 * @interface TeamApiInterface
 */
export interface TeamApiInterface {
    /**
     * 
     * @summary Delete team by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    deleteTeamRaw(requestParameters: DeleteTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete team by ID
     */
    deleteTeam(requestParameters: DeleteTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete the payment receipt for a team
     * @param {string} id 
     * @param {string} [tournamentId] Tournament context used to validate receipt availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    deleteTeamPaymentReceiptRaw(requestParameters: DeleteTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the payment receipt for a team
     */
    deleteTeamPaymentReceipt(requestParameters: DeleteTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Download the payment receipt file for a team
     * @param {string} id 
     * @param {string} [tournamentId] Tournament context used to validate receipt availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    downloadTeamPaymentReceiptRaw(requestParameters: DownloadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Download the payment receipt file for a team
     */
    downloadTeamPaymentReceipt(requestParameters: DownloadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Edit team details
     * @param {string} id 
     * @param {TeamEdit} teamEdit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    editTeamRaw(requestParameters: EditTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>>;

    /**
     * Edit team details
     */
    editTeam(requestParameters: EditTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team>;

    /**
     * Returns a list of all registered teams
     * @summary Get all teams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    getAllTeamsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Team>>>;

    /**
     * Returns a list of all registered teams
     * Get all teams
     */
    getAllTeams(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Team>>;

    /**
     * 
     * @summary Get team by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    getTeamByIdRaw(requestParameters: GetTeamByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>>;

    /**
     * Get team by ID
     */
    getTeamById(requestParameters: GetTeamByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team>;

    /**
     * 
     * @summary Get officials for team by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    getTeamOfficialsRaw(requestParameters: GetTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Person>>>;

    /**
     * Get officials for team by ID
     */
    getTeamOfficials(requestParameters: GetTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Person>>;

    /**
     * 
     * @summary Get payment receipt metadata for a team
     * @param {string} id 
     * @param {string} [tournamentId] Tournament context used to validate receipt availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    getTeamPaymentReceiptRaw(requestParameters: GetTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamPaymentReceipt>>;

    /**
     * Get payment receipt metadata for a team
     */
    getTeamPaymentReceipt(requestParameters: GetTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamPaymentReceipt>;

    /**
     * 
     * @summary Get players for team by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    getTeamPlayersRaw(requestParameters: GetTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Player>>>;

    /**
     * Get players for team by ID
     */
    getTeamPlayers(requestParameters: GetTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Player>>;

    /**
     * 
     * @summary Register a new team
     * @param {string} id 
     * @param {TeamRegistrationRequest} teamRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    registerTeamInTournamentRaw(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>>;

    /**
     * Register a new team
     */
    registerTeamInTournament(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team>;

    /**
     * 
     * @summary Update officials for team by ID
     * @param {string} id 
     * @param {Array<Person>} person 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    updateTeamOfficialsRaw(requestParameters: UpdateTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Person>>>;

    /**
     * Update officials for team by ID
     */
    updateTeamOfficials(requestParameters: UpdateTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Person>>;

    /**
     * 
     * @summary Update players for team by ID
     * @param {string} id 
     * @param {Array<Player>} player 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    updateTeamPlayersRaw(requestParameters: UpdateTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Player>>>;

    /**
     * Update players for team by ID
     */
    updateTeamPlayers(requestParameters: UpdateTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Player>>;

    /**
     * 
     * @summary Update status for team by ID
     * @param {string} id 
     * @param {UpdateTeamStatusRequest} updateTeamStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    updateTeamStatusRaw(requestParameters: UpdateTeamStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>>;

    /**
     * Update status for team by ID
     */
    updateTeamStatus(requestParameters: UpdateTeamStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team>;

    /**
     * 
     * @summary Upload or replace the payment receipt for a team
     * @param {string} id 
     * @param {Blob} file Payment receipt file (PDF or image)
     * @param {string} [tournamentId] Tournament context used to validate receipt availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApiInterface
     */
    uploadTeamPaymentReceiptRaw(requestParameters: UploadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamPaymentReceipt>>;

    /**
     * Upload or replace the payment receipt for a team
     */
    uploadTeamPaymentReceipt(requestParameters: UploadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamPaymentReceipt>;

}

/**
 * 
 */
export class TeamApi extends runtime.BaseAPI implements TeamApiInterface {

    /**
     * Delete team by ID
     */
    async deleteTeamRaw(requestParameters: DeleteTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteTeam.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete team by ID
     */
    async deleteTeam(requestParameters: DeleteTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTeamRaw(requestParameters, initOverrides);
    }

    /**
     * Delete the payment receipt for a team
     */
    async deleteTeamPaymentReceiptRaw(requestParameters: DeleteTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteTeamPaymentReceipt.');
        }

        const queryParameters: any = {};

        if (requestParameters.tournamentId !== undefined) {
            queryParameters['tournamentId'] = requestParameters.tournamentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}/payment-receipt`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the payment receipt for a team
     */
    async deleteTeamPaymentReceipt(requestParameters: DeleteTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTeamPaymentReceiptRaw(requestParameters, initOverrides);
    }

    /**
     * Download the payment receipt file for a team
     */
    async downloadTeamPaymentReceiptRaw(requestParameters: DownloadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling downloadTeamPaymentReceipt.');
        }

        const queryParameters: any = {};

        if (requestParameters.tournamentId !== undefined) {
            queryParameters['tournamentId'] = requestParameters.tournamentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}/payment-receipt/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download the payment receipt file for a team
     */
    async downloadTeamPaymentReceipt(requestParameters: DownloadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadTeamPaymentReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edit team details
     */
    async editTeamRaw(requestParameters: EditTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling editTeam.');
        }

        if (requestParameters.teamEdit === null || requestParameters.teamEdit === undefined) {
            throw new runtime.RequiredError('teamEdit','Required parameter requestParameters.teamEdit was null or undefined when calling editTeam.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/teams/{id}/edit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TeamEditToJSON(requestParameters.teamEdit),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamFromJSON(jsonValue));
    }

    /**
     * Edit team details
     */
    async editTeam(requestParameters: EditTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team> {
        const response = await this.editTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of all registered teams
     * Get all teams
     */
    async getAllTeamsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Team>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TeamFromJSON));
    }

    /**
     * Returns a list of all registered teams
     * Get all teams
     */
    async getAllTeams(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Team>> {
        const response = await this.getAllTeamsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get team by ID
     */
    async getTeamByIdRaw(requestParameters: GetTeamByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTeamById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamFromJSON(jsonValue));
    }

    /**
     * Get team by ID
     */
    async getTeamById(requestParameters: GetTeamByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team> {
        const response = await this.getTeamByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get officials for team by ID
     */
    async getTeamOfficialsRaw(requestParameters: GetTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Person>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTeamOfficials.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}/officials`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonFromJSON));
    }

    /**
     * Get officials for team by ID
     */
    async getTeamOfficials(requestParameters: GetTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Person>> {
        const response = await this.getTeamOfficialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get payment receipt metadata for a team
     */
    async getTeamPaymentReceiptRaw(requestParameters: GetTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamPaymentReceipt>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTeamPaymentReceipt.');
        }

        const queryParameters: any = {};

        if (requestParameters.tournamentId !== undefined) {
            queryParameters['tournamentId'] = requestParameters.tournamentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}/payment-receipt`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamPaymentReceiptFromJSON(jsonValue));
    }

    /**
     * Get payment receipt metadata for a team
     */
    async getTeamPaymentReceipt(requestParameters: GetTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamPaymentReceipt> {
        const response = await this.getTeamPaymentReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get players for team by ID
     */
    async getTeamPlayersRaw(requestParameters: GetTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Player>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTeamPlayers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/teams/{id}/players`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlayerFromJSON));
    }

    /**
     * Get players for team by ID
     */
    async getTeamPlayers(requestParameters: GetTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Player>> {
        const response = await this.getTeamPlayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register a new team
     */
    async registerTeamInTournamentRaw(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling registerTeamInTournament.');
        }

        if (requestParameters.teamRegistrationRequest === null || requestParameters.teamRegistrationRequest === undefined) {
            throw new runtime.RequiredError('teamRegistrationRequest','Required parameter requestParameters.teamRegistrationRequest was null or undefined when calling registerTeamInTournament.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/tournaments/{id}/register`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TeamRegistrationRequestToJSON(requestParameters.teamRegistrationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamFromJSON(jsonValue));
    }

    /**
     * Register a new team
     */
    async registerTeamInTournament(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team> {
        const response = await this.registerTeamInTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update officials for team by ID
     */
    async updateTeamOfficialsRaw(requestParameters: UpdateTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Person>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTeamOfficials.');
        }

        if (requestParameters.person === null || requestParameters.person === undefined) {
            throw new runtime.RequiredError('person','Required parameter requestParameters.person was null or undefined when calling updateTeamOfficials.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/teams/{id}/officials`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.person.map(PersonToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonFromJSON));
    }

    /**
     * Update officials for team by ID
     */
    async updateTeamOfficials(requestParameters: UpdateTeamOfficialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Person>> {
        const response = await this.updateTeamOfficialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update players for team by ID
     */
    async updateTeamPlayersRaw(requestParameters: UpdateTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Player>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTeamPlayers.');
        }

        if (requestParameters.player === null || requestParameters.player === undefined) {
            throw new runtime.RequiredError('player','Required parameter requestParameters.player was null or undefined when calling updateTeamPlayers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/teams/{id}/players`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.player.map(PlayerToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlayerFromJSON));
    }

    /**
     * Update players for team by ID
     */
    async updateTeamPlayers(requestParameters: UpdateTeamPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Player>> {
        const response = await this.updateTeamPlayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update status for team by ID
     */
    async updateTeamStatusRaw(requestParameters: UpdateTeamStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Team>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTeamStatus.');
        }

        if (requestParameters.updateTeamStatusRequest === null || requestParameters.updateTeamStatusRequest === undefined) {
            throw new runtime.RequiredError('updateTeamStatusRequest','Required parameter requestParameters.updateTeamStatusRequest was null or undefined when calling updateTeamStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/teams/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTeamStatusRequestToJSON(requestParameters.updateTeamStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamFromJSON(jsonValue));
    }

    /**
     * Update status for team by ID
     */
    async updateTeamStatus(requestParameters: UpdateTeamStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Team> {
        const response = await this.updateTeamStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload or replace the payment receipt for a team
     */
    async uploadTeamPaymentReceiptRaw(requestParameters: UploadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamPaymentReceipt>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling uploadTeamPaymentReceipt.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadTeamPaymentReceipt.');
        }

        const queryParameters: any = {};

        if (requestParameters.tournamentId !== undefined) {
            queryParameters['tournamentId'] = requestParameters.tournamentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/teams/{id}/payment-receipt`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamPaymentReceiptFromJSON(jsonValue));
    }

    /**
     * Upload or replace the payment receipt for a team
     */
    async uploadTeamPaymentReceipt(requestParameters: UploadTeamPaymentReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamPaymentReceipt> {
        const response = await this.uploadTeamPaymentReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
